<template>
  <div>
    <div class="background" :style="{ color: slideData.text_color }">
      <div class="row">
        <div class="column top">
          <div class="insurance-body">
            <span
              class="title-insurance-padding"
              :style="{ color: slideData.text_color }"
              v-html="slideData.insurance_text"
            ></span>
            <div ref="insuranceScroll" class="insurance-scroll">
              <div
                class="insurance-plans"
                v-for="data in getFacilityInsurance"
                :key="data.id"
              >
                <div class="insurance-coverage">
                  <span class="coverage-span">
                    ${{ toLocaleString(data.coverage_amount) }}
                  </span>
                  <span class="coverage-text">Coverage</span>
                </div>
                <div class="insurance-monthly">
                  <span class="monthly-span">${{ data.monthly_premium }}</span>
                  <span class="monthly-span-text">/month</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="row">
        <div class="column"></div>
        <div class="column" :style="{ background: slideData.background_color }">
          <p
            v-if="slideData.include_copy"
            v-html="slideData.slide_text"
            class="insurance-text"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

function scrollBy(time, element) {
  let target = element.scrollHeight
  // const elementInitialScrollPosition = element.scrollTop
  var currentPosition = element.scrollTop
  var scrollInterval = target / time
  var intervalTime = 2
  setInterval(function () {
    currentPosition = currentPosition + scrollInterval * intervalTime
    element.scrollTop = currentPosition
    if (currentPosition >= target) {
      // element.scrollTop = elementInitialScrollPosition
      // currentPosition = element.scrollTop
      currentPosition = 0
    }
  }, intervalTime)
}

export default {
  name: 'insurance_4',
  props: {
    slideData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      facilityInsurances: (state) =>
        (state.facilityInsurances || []).filter(
          ({ enabled, deleted }) => enabled && !deleted
        ),
    }),
    getFacilityInsurance() {
      let insuranceObj = this.facilityInsurances
      if (insuranceObj.length) {
        return insuranceObj.sort(
          (a, b) => a.coverage_amount - b.coverage_amount
        )
      } else {
        return []
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      scrollBy(15000, this.$refs['insuranceScroll'])
    })
  },
  methods: {
    toLocaleString(number) {
      return Number(number).toLocaleString()
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.background {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: 100vh;
}
.row {
  display: flex;
  flex-grow: 1;
  flex-basis: 100%;
}
.column {
  flex-grow: 1;
  flex-basis: 100%;
}
.top {
  background: rgba(2, 2, 2, 0.5);
}
.insurance-text {
  text-align: left;
  font-size: 70px;
  color: inherit;
  /* width: 90%; */
  /* padding-left: 10%;
  padding-top: 10%; */
  padding: 90px;
  padding-left: 132px;
}
.insurance-coverage {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  font-size: 40px;
}
.insurance-scroll {
  overflow-y: scroll;
  height: 300px;
  margin-top: 30px;
  /* width: 80%; */
  /* justify-content: space-between; */
  font-size: 50px;
}
.insurance-scroll::-webkit-scrollbar {
  display: none;
}
.insurance-body {
  /* margin: 60px 30px; */
  /* min-height: 539; */
  text-align: left;
  /* max-height: 30vh !important; */
  /* padding: 140px; */
  padding: 80px 100px 45px 100px;
  font-size: 44px;
  color: inherit;
  /* height: 100%; */
}

.insurance-plans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-clip: padding-box;
  padding-top: 5px;
  /* padding-bottom: 5px; */
}
.insurance-plans:not(:last-child) {
  border-bottom: 2px solid white;
}
.coverage-span {
  /* margin-right: 5px; */
  /* min-width: 150px; */
  text-align: left;
  font-weight: bold;
}
.coverage-text {
  padding-left: 10px;
}
.monthly-span {
  /* padding-right: 20px; */
  max-width: 130px;
  text-align: right;
  font-weight: bold;
  font-size: 70px;
}
.monthly-span-text {
  font-size: 40px;
}
.title-insurance-padding {
  font-size: 70px;
}
</style>
